<template>
    <toolbar-option>
        <template slot="primary">
            <input v-model="value" type="text" @change="setChangedData(true)">
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'input-validation-message',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Validation Message',
            value: '',
        };
    },

    watch: {
        value() {
            this.selectedElements[0].validationMessageNew = this.value;
            this.onOptionChange(this.value);
        },
    },

    methods: {
        onSelectedElement() {
            this.value = this.selectedElements[0].validationMessageNew;
        },
    },
};
</script>
